export default {
  home: {
    title: 'HTML5遊戲集合',
    subtitle: '在瀏覽器中即時遊玩，無需下載，即玩即走！',
    browseGames: '瀏覽遊戲',
    popularGames: '熱門遊戲',
    newGames: '新遊戲',
    recommendedGames: '推薦遊戲',
    recentlyPlayed: '最近玩過',
    popular: '熱門',
    genres: {
      casual: '休閒',
      puzzle: '益智',
      racing: '賽車',
      racing_driving: '賽車與駕駛',
      shooter: '射擊',
      simulation: '模擬',
      strategy: '策略',
      sports: '體育',
      agility: '敏捷',
      battle: '對戰',
      care: '照顧',
      cooking: '烹飪',
      football: '足球',
      '.IO': '即時對戰',
      merge: '合併',
      all: '全部',
      other: '其他',
      dressup: '換裝',
      adventure: '冒險',
      mahjong_connect: '麻將與連接',
      jigsaw: '拼圖',
      basketball: '籃球',
      quiz: '問答',
      bubble_shooter: '泡泡射擊',
      match3: '三消',
      boardgames: '棋盤遊戲',
      educational: '教育',
      cards: '卡牌'
    }
  },
  games: {
    playNow: '立即遊玩',
    relatedGames: '相關遊戲',
    instructions: '遊戲說明',
    controlsTitle: '遊戲控制',
    addToFavorites: '加入收藏',
    removeFromFavorites: '從收藏中移除',
    share: '分享遊戲',
    reportIssue: '報告問題',
    fullscreen: '全屏模式',
    exitFullscreen: '退出全屏'
  },
  categories: {
    title: '遊戲類別',
    subtitle: '探索豐富的遊戲類別',
    allCategories: '所有類別',
    gamesInCategory: '{count}款遊戲',
    categoryDescription: '在這裡你可以找到所有{category}類別的遊戲。從各種風格中選擇，立即開始遊玩！',
    pageTitle: '遊戲類別',
    pageDescription: '探索各種遊戲類別，找到你喜愛的遊戲類型',
    allGames: '所有遊戲',
    gamesFound: '找到{count}款遊戲',
    other: '其他',
    taggedGames: '{tag}遊戲',
    noGamesInCategory: '此類別暫無遊戲',
    loadMore: '加載更多',
    otherGames: '其他遊戲',
    seoTitle: 'GoGameVault - 遊戲類別 | 免費線上HTML5遊戲',
    seoDescription: '探索GoGameVault多樣化的遊戲類別，找到你喜愛的遊戲類型，如動作、益智、街機、體育、賽車等。',
    seoKeywords: '遊戲類別,線上遊戲,免費遊戲,HTML5遊戲,瀏覽器遊戲',
    descriptions: {
      'Casual': '簡單易玩的休閒遊戲，適合所有年齡層的玩家，無壓力地享受遊戲樂趣。',
      'Puzzle': '透過解決謎題和智力挑戰帶來滿足感的腦力訓練益智遊戲。',
      'Racing & Driving': '體驗速度與激情，挑戰各種賽道的刺激賽車和駕駛遊戲。',
      'Shooter': '測試你的瞄準精度和反應時間的射擊遊戲，擊敗所有敵人。',
      'Simulation': '從城市管理到飛機駕駛，模擬現實世界中的各種體驗，充分體驗不同角色。',
      'Strategy': '需要謹慎規劃和戰術思考的策略遊戲，制定最佳戰略以取得勝利。',
      'Sports': '模擬各種運動項目的運動遊戲，展示你的運動天賦。',
      'Agility': '測試反應速度和協調能力的敏捷遊戲，快速應對各種挑戰。',
      'Battle': '與對手進行激烈競爭的對戰遊戲，憑藉技巧和策略取得勝利。',
      'Care': '體驗照顧寵物、病人或其他角色的樂趣的照顧遊戲。',
      'Cooking': '展示料理才能，製作美味料理並管理餐廳的料理遊戲。',
      'Football': '體驗世界上最受歡迎的運動，展示你的球技和戰術的足球遊戲。',
      '.IO': '即時對戰遊戲，多人線上競技類遊戲，與全球玩家一起競爭和成長。',
      'Merge': '合併類遊戲，透過合併相同物品來創造新物品，簡單有趣且令人上癮。',
      'other': '不屬於常規類別的獨特遊戲體驗。',
      'generic': '探索各種{tag}類型的遊戲，找到你的最愛。'
    }
  },
  search: {
    title: '搜尋結果',
    placeholder: '搜尋遊戲...',
    resultsFor: '「{query}」的搜尋結果',
    noResults: '未找到遊戲',
    noResultsMessage: '未找到與「{query}」相關的遊戲',
    tryAgain: '嘗試使用其他關鍵詞或瀏覽類別。',
    returnToHomepage: '返回首頁',
    foundResults: '找到{count}款遊戲',
    seoTitle: '搜尋「{query}」- GoGameVault | 免費線上HTML5遊戲',
    seoDescription: '在GoGameVault上搜尋與「{query}」相關的免費線上HTML5遊戲。各種好玩的遊戲無需下載，直接在瀏覽器中遊玩。'
  },
  gameDetail: {
    title: '遊戲詳情',
    gameTitle: '遊戲標題',
    genres: '遊戲類型',
    tags: '標籤',
    gameDescription: '遊戲描述',
    controlsAndInstructions: '控制與說明',
    similarGames: '類似遊戲',
    new: '新遊戲',
    playAmazingGame: '立即遊玩這款精彩遊戲',
    noSimilarGames: '無類似遊戲',
    gameNotFound: '未找到遊戲',
    gameNotExistOrRemoved: '此遊戲不存在或已被移除',
    backToHome: '返回首頁',
    seoTitle: '{title} - 免費線上遊玩 | GoGameVault',
    seoTitleNotFound: '未找到遊戲 | GoGameVault',
    seoKeywords: '{title}, 線上遊戲, 免費遊戲, {tags}, HTML5遊戲',
    gameUnavailable: '遊戲暫時不可用',
    tryAgainLater: '請稍後再試',
    share: '分享',
    openInNewTab: '在新標籤中打開'
  },
  about: {
    title: '關於我們',
    aboutUs: '關於我們',
    ourMission: '我們的使命',
    contactUs: '聯絡我們',
    privacyPolicy: '私隱政策',
    termsOfService: '服務條款',
    feedbackTitle: '意見反饋',
    feedbackText: '我們一直在努力改進網站。如有建議或問題，請告訴我們！',
    missionTitle: '我們的使命',
    missionText1: 'GoGameVault致力於為用戶提供最佳的免費線上遊戲體驗。我們精心挑選有趣且高質量的HTML5遊戲，無需下載即可享受。',
    missionText2: '我們的目標是創建一個用戶友好的遊戲平台，玩家可以輕鬆找到並遊玩喜愛的遊戲。',
    feature1Title: '精心挑選的遊戲',
    feature1Text: '我們仔細選擇每款遊戲，確保高質量的圖形和流暢的遊戲體驗。',
    feature2Title: '隨時隨地遊玩',
    feature2Text: '所有遊戲都可以直接在瀏覽器中運行，無需下載或安裝任何額外軟件。',
    feature3Title: '完全免費',
    feature3Text: '我們的所有遊戲都完全免費，沒有隱藏費用或應用內購買。',
    contactTitle: '聯絡我們',
    contactText: '如有任何疑問、建議或反饋，請隨時聯絡我們。我們重視用戶意見，並致力於持續改進我們的服務。',
    seoTitle: 'GoGameVault - 關於我們 | 免費線上HTML5遊戲',
    seoDescription: 'GoGameVault是一個免費線上HTML5遊戲平台，提供精選遊戲，無需下載即可隨時隨地遊玩。了解我們的使命和特色。',
    seoKeywords: '線上遊戲,免費遊戲,HTML5遊戲,瀏覽器遊戲,無需下載'
  },
  notFound: {
    title: '頁面未找到',
    message: '抱歉，你訪問的頁面不存在或已被移除。讓我們回到正軌！',
    returnHome: '返回首頁',
    goBack: '返回上一頁',
    popularGames: '熱門遊戲推薦',
    popularGamesDesc: '探索這些精選遊戲，開始你的遊戲之旅',
    seoTitle: '頁面未找到 - GoGameVault',
    seoDescription: '抱歉，你訪問的頁面在GoGameVault中不存在。瀏覽熱門遊戲以獲取新的遊戲體驗。'
  },
  categoryGames: {
    games: '遊戲',
    gamesAvailable: '{count}款遊戲可用',
    noGamesFound: '未找到遊戲',
    noGamesInCategory: '此類別暫無遊戲',
    exploreCategories: '探索其他類別',
    backToCategories: '返回類別',
    invalidCategory: '無效類別',
    categoryNotExist: '你尋找的類別不存在。',
    browseCategories: '瀏覽所有類別',
    category: '類別',
    seoTitle: '{tag}遊戲 - 線上遊玩 - GoGameVault',
    seoDescriptionWithGames: '瀏覽並免費遊玩{count}款精選{tag}遊戲。所有遊戲均可直接在瀏覽器中遊玩，無需下載。',
    seoDescriptionDefault: '瀏覽並免費遊玩我們的{tag}遊戲。所有遊戲均可直接在瀏覽器中遊玩，無需下載。',
    seoKeywords: '{tag}遊戲,免費線上遊戲,瀏覽器遊戲'
  }
}; 